<template>
  <div class="button-footer">
    <!-- Secondary button -->
    <button
      v-if="slideIndex !== 0"
      @click="onBack"
      class="button-secondary"
      style="margin-bottom: 10px"
      :name="`${instructions.currentStep}_carousel_backButton`"
      :id="`${instructions.currentStep}_carousel_backButton`"
    >{{ $t('common.back') }}</button>

    <!-- Primary button -->
    <button
      @click="onNext"
      class="button-primary"
      :name="`${instructions.currentStep}_carousel_nextButton`"
      :id="`${instructions.currentStep}_carousel_nextButton`"
    >{{ $t('common.next') }}</button>
  </div>
</template>

<script>
export default {
  name: 'CarouselFooter',
  props: {
    slideIndex: {
      type: Number,
    },
    isLastSlide: {
      type: Boolean,
      default: false,
    },
    instructions: {
      type: Object,
      required: true,
    }
  },
  methods: {
    onBack() {
      this.$emit('onBack');
    },
    onNext() {
      this.$emit('onNext');
    },
  },
}
</script>
